// src/pages/AIModuleRoadmap.jsx
import { ArrowRight, Cpu, TrendingUp, Globe } from "lucide-react";
import { motion } from "framer-motion";

// Basit Card component (shadcn yerine kendi yazdık)
function Card({ children, className }) {
  return (
    <div className={`bg-white border rounded-2xl shadow-md ${className || ""}`}>
      {children}
    </div>
  );
}

function CardContent({ children, className }) {
  return <div className={`p-4 ${className || ""}`}>{children}</div>;
}

export default function AIModuleRoadmap() {
  const steps = [
    {
      title: "Bugün",
      model: "ResNet50",
      desc: "350+ mekân, 25-50 görsel/sınıf için transfer learning ile hızlı ve stabil.",
      icon: Cpu,
    },
    {
      title: "Yakın Gelecek",
      model: "EfficientNetV2 / Vision Transformer",
      desc: "Daha büyük veri setlerinde daha yüksek doğruluk ve esneklik.",
      icon: TrendingUp,
    },
    {
      title: "Uzak Gelecek",
      model: "CLIP / Multimodal AI",
      desc: "Görsel + metin birlikte işleyerek mekânı bağlamsal olarak anlama.",
      icon: Globe,
    },
  ];

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-3xl font-bold text-center mb-12">
        Yapay Zekâ Yol Haritamız
      </h1>
      <div className="relative ">
        {steps.map((step, idx) => {
          const Icon = step.icon;
          return (
            <motion.div
              key={idx}
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 200 }}
              className="mb-12 last:mb-0 relative"
            >
              <div className="absolute -left-10 top-2 flex items-center justify-center w-8 h-8 rounded-full bg-indigo-500 text-white shadow-lg">
                <Icon className="w-4 h-4" />
              </div>
              <Card>
                <CardContent>
                  <h2 className="text-xl font-semibold mb-2">{step.title}</h2>
                  <p className="text-lg font-bold text-indigo-600 mb-2">{step.model}</p>
                  <p className="text-gray-600">{step.desc}</p>
                </CardContent>
              </Card>
            </motion.div>
          );
        })}
      </div>
      <div className="mt-10 flex items-center justify-center gap-4">
        {steps.map((step, idx) => (
          <div key={idx} className="flex items-center gap-2">
            <span className="text-sm font-medium text-gray-200">{step.title}</span>
            {idx < steps.length - 1 && (
              <ArrowRight className="w-5 h-5 text-indigo-500" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
